import { h, FunctionComponent, ComponentChildren } from "preact"; /** @jsx h */
import { clsx } from 'clsx';


export type IItemProps = {
    children?: ComponentChildren; // e.g. Intro <span className="sr-only">(current)</span>
    linkTo: string; // e.g. ./index.html
    highlight?: boolean;
    align?: 'left' | 'right';
    onClick?: (event: MouseEvent) => void;
};

export const Item = (props: IItemProps) => {

    return (
        <li className={clsx("nav-item", props.highlight && "highlight")}>
			<a className="nav-link" href={props.linkTo} onClick={props.onClick}>
            {
                props.children
            }
            </a>
        </li>
    );
}
  
